import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useNavigate } from "react-router-dom";

const Privacy = () => {
  const navigate = useNavigate();
  const handleBookingClick = () => navigate("/book");

  return (
    <div className="min-h-screen bg-background">
      <Header onBookingClick={handleBookingClick} />
      
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-serif mb-8">Privacy Policy</h1>
          <div className="prose prose-lg max-w-none space-y-6">
            
            <section>
              <h2 className="text-2xl font-semibold mb-4">Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you contact us for services, request estimates, or book appointments. This may include your name, email address, phone number, and project details.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide and deliver our organizing services</li>
                <li>To communicate with you about appointments and services</li>
                <li>To send you updates and promotional materials (with your consent)</li>
                <li>To improve our services and customer experience</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Data Security</h2>
              <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
              <p>If you have questions about this privacy policy, please contact us at:</p>
              <p>Email: hello@organizebydesignmichigan.com<br />
              Phone: 616 727-0343</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Updates</h2>
              <p>This privacy policy may be updated from time to time. We will notify you of any changes by posting the new policy on this page.</p>
              <p className="text-sm text-muted-foreground">Last updated: January 2025</p>
            </section>
          </div>
        </div>
      </main>

      <Footer onBookingClick={handleBookingClick} />
    </div>
  );
};

export default Privacy;